//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { isSbAnyLinkFilled } from '~/utils/helpers';

export default {
  name: 'BlokHomeWhatTheyWrite',
  props: {
    blok: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      isVisibleAos: false,
      isVisibleSwiper: false,
      options: {
        loop: false,
        slidesPerView: 'auto',
        watchOverflow: true,
        spaceBetween: 10,
        autoplay: {
          delay: 3000,
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
      },
    }
  },
  computed: {
    aosAnimate() {
      return this.isVisibleAos ? 'aos-animate' : null;
    },
    heading() {
      switch(this.index) {
        case 0:
          return 'h1';
        default:
          return 'h2';
      }
    },
    swiper() {
      return this.$refs.refSwiper.$swiper;
    },
  },
  methods: {
    isLinkFilled(link) {
      return isSbAnyLinkFilled(link);
    },
    aosVisibilityChanged(isVisible) {
      this.isVisibleAos = isVisible;
    },
    swiperVisibilityChanged(isVisible) {
      this.isVisibleSwiper = isVisible;

      if (isVisible) {
        this.swiper.autoplay.start();
      } else {
        this.swiper.autoplay.stop();
      }
    },
    autoplayStart() {
      this.$el.classList.remove('swiper-pagination-pause');
    },
    autoplayStop() {
      this.$el.classList.add('swiper-pagination-pause');
    },
    handleSwiperStop() {
      this.swiper.autoplay.stop();
    },
    handleSwiperStart() {
      if (this.isVisibleSwiper) {
        this.swiper.autoplay.start();
      }
    },
  },
  mounted() {
    this.swiper
      .on('autoplayStart', () => {
        this.autoplayStart();
      })
      .on('autoplayStop', () => {
        this.autoplayStop();
      });
  },
}
